import Vue from 'vue';

((Vue, tinySlider) => {
  "use stricts";

  Vue.component('CarouselItem', {
    template: `
      <div class="carousel__item">
        <slot></slot>
      </div>
    `,
  })

  Vue.component('Carousel', {
    props: {
      carouselId: {
        required: true,
        type: String
      },
      slideBy: {
        reqiured: true,
        type: Number,
        default: 1
      },
      gutter: {
        reqiured: false,
        type: Number,
        default: 0
      },
      items: {
        required: true,
        type: Number,
        default: 1
      },
      loop: {
        required: false,
        type: Boolean,
        default: false
      },
      autoplay: {
        required: false,
        type: Boolean,
        default: false
      },
      nav: {
        required: false,
        type: Boolean,
        default: true
      },
      controls: {
        required: false,
        type: Boolean,
        default: true
      },
      type: {
        required: false,
        type: Number,
        default: 1
      },
      responsive: {
        required: false,
        type: Object
      }
    },
    template: `
      <div class="carousel" :class="{ 'carousel--spacing': type == 1}">
        <div class="carousel__holder" v-bind:id="carouselId">
          <slot></slot>
        </div>
      </div>
    `,
    data: function() {
      return {
        slider: null
      };
    },
    mounted: function() {
      this.$nextTick(function() {

        let sliderOptions = {
          container: `#${this.carouselId}`,
          items: this.items,
          slideBy: this.slideBy,
          loop: this.loop,
          autoplay: this.autoplay,
          nav: this.nav,
          controls: this.controls,
          controlsText: ['', ''],
          touch: true,
          mouseDrag: true,
          gutter: this.gutter,
					edgePadding: 40,
        };

        if(this.responsive) {
          sliderOptions.responsive = this.responsive;
        }

        this.slider = tinySlider.tns(sliderOptions);

        if(this.type == 2) {
          const { controlsContainer, navContainer, container } = this.slider.getInfo();
					container.classList.add('carousel__holder--center');
          container.parentElement.parentElement.parentElement.parentElement.classList.add('arrow-bottom');
          navContainer.appendChild(controlsContainer);
        }
      });
    }
  });

})(Vue, tinySlider);



// WEBPACK FOOTER //
// ./components/carousel/carousel.js